import HttpService from './baseHttp'

// 看板查询接口
export const HttpTimePredictionList = (data) => HttpService.get('/api/v2/timePrediction/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

// 查询地址列表
export const HttpAddressList = (data) => HttpService.get('/api/v2/address/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//保存物流预估时间
export const HttpSaveTimePrediction  = (data) => HttpService.post('/api/v2/timePrediction/saveAndUpdate', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB});
//编辑
export const HttpGetOne = (data) => HttpService.get('/api/v2/timePrediction/getOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
//删除
export const HttpDeleteTimePrediction = (data) => HttpService.get('/api/v2/timePrediction/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//物流基础费用
// 看板查询接口
export const HttpCostPredictionList = (data) => HttpService.get('/api/v2/costPrediction/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpSaveCostPrediction  = (data) => HttpService.post('/api/v2/costPrediction/saveAndUpdate', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpCostGetOne = (data) => HttpService.get('/api/v2/costPrediction/getOne', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpDeleteCostPrediction = (data) => HttpService.get('/api/v2/costPrediction/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

//进口商管理
export const HttpImporterList = (data) => HttpService.get('/api/v2/importer/query', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpSaveImporter  = (data) => HttpService.post('/api/v2/importer/saveAndUpdate', data, { headers: { "Content-Type": "application/json" },baseURL: process.env.VUE_APP_APIURL_FBB});

export const HttpImporterGetOne = (data) => HttpService.get('/api/v2/importer/detail', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB});
